module.exports = __webpack_public_path__ + "static/media/BannerWithoutImage@1x.74c8efcfb81b47fdb41121566af8b26d.jpg";